import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g clipPath="url(#clip0_1786_28435)">
        <path
          fill="#F90"
          d="M15.01 3.5l11.114 19.25a1.166 1.166 0 01-1.01 1.75H2.886a1.167 1.167 0 01-1.01-1.75L12.99 3.5a1.167 1.167 0 012.02 0zm-2.177 15.166V21h2.334v-2.334h-2.334zm0-8.166v5.833h2.334V10.5h-2.334z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1786_28435">
          <path fill="#fff" d="M0 0H28V28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
